import CoVPercentageField from './CoVPercentageField'

export default CoVPercentageField
